import { SubmitReportVocBody } from "src/entity/common/global.entity";
import http from "../utils/http-common";
import { FilterColumnProps } from "src/entity/common/query.entity";
import { FilterManualWasteWater, UpdateManualWasteWater } from "src/entity/waste-water/manual-waste-water.entity";
import { FilterReportVocEmission } from "src/entity/waste-water/report-voc-emission.entity";
import { CreateSetupWasteWater, FilterSetupWasteWater, UpdateSetupWasteWaterDto } from "src/entity/waste-water/setup-information.entity";

const basePath = "/api/waste-water-treatment";
const baseMasterPath = "/api/masterdata";

export const getMasterDataEmission = () => {
  return http.get(baseMasterPath, { params: { label: "Emission", type: "global" } });
};

// Waste Water Setup Information
export const getYearSetupWasteWater = () => {
  return http.get(`${basePath}/setup/year`);
};
export const getAllSettingWasteWater = (query: { isActive: boolean }) => {
  return http.get(`${baseMasterPath}/setting-waste-water`, { params: query });
};

export const createSetupWasteWater = (body: CreateSetupWasteWater) => {
  return http.post(`${basePath}/information`, body);
};
export const updateSetupWasteWater = (data: UpdateSetupWasteWaterDto) => {
  return http.patch(`${basePath}/information`, data);
};
export const deleteSetupWasteWater = (_id: string) => {
  return http.delete(`${basePath}/information/${_id}`);
};
export const searchSetupWasteWater = (data: FilterSetupWasteWater) => {
  return http.post(`${basePath}/search/information`, data);
};
export const getFilterColumnSetupWasteWater = (params: FilterColumnProps) => {
  return http.get(`${basePath}/information/filter-column`, { params });
};

// Waste Water Approval

export const getOptionMonthSubmit = (year: string) => {
  return http.get(`${basePath}/report/voc-emission/approve/month/${year}`);
};

export const submitReportVoc = (data: SubmitReportVocBody) => {
  return http.post(`${basePath}/report/voc-emission/approve/submit-report`, data);
};

export const getInfoStepApprove = (approveId: string) => {
  return http.get(`${basePath}/report/voc-emission/approve/info-step/${approveId}`);
};

export const getOptionVocApprove = () => {
  return http.get(`${basePath}/report/voc-emission/approve/filter-voc-approve`);
};

export const updateApproveStep = (data: any) => {
  return http.patch(`${basePath}/report/voc-emission/approve/approve-step`, data);
};

// Waste Water Manual
export const getFilterColumnManualWasteWater = (params: { year: string }) => {
  return http.get(`${basePath}/manual-voc-water/filter-column`, { params });
};
export const searchManualVocWater = (data: FilterManualWasteWater) => {
  return http.post(`${basePath}/search/manual-voc-water`, data);
};
export const updateManualWasteWater = (_id: string, data: UpdateManualWasteWater) => {
  return http.patch(`${basePath}/manual-voc-water/${_id}`, data);
};

// Report VOC Emission
export const getFilterColumnWWReportVocEmission = (params: { year: string }) => {
  return http.get(`${basePath}/report-voc/filter-column`, { params });
};
export const searchWWReportVocEmission = (data: FilterReportVocEmission) => {
  return http.post(`${basePath}/search/report-voc-emission`, data);
};
export const calculateReportVocWasteWater = (_id: string) => {
  return http.patch(`${basePath}/report-voc/calculation/${_id}`);
};
export const calculateReportVocAfterRejectApproval = (year: string) => {
  return http.post(`${basePath}/calculation/report/action-reject/${year}`);
};
// emissionControl id
export const calculateReportVocAfterUpdateMasterWW = (_id: string) => {
  return http.patch(`${basePath}/report-voc/calculation/change-master/${_id}`);
};

export const SettingService = {
  getYearSetupWasteWater,
  createSetupWasteWater,
  updateSetupWasteWater,
  deleteSetupWasteWater,
  searchSetupWasteWater,
  getFilterColumnSetupWasteWater,
  getAllSettingWasteWater,
  getMasterDataEmission,
  getFilterColumnManualWasteWater,
  searchManualVocWater,
  updateManualWasteWater,
  getFilterColumnWWReportVocEmission,
  searchWWReportVocEmission,
  calculateReportVocWasteWater,
  calculateReportVocAfterRejectApproval,
  getOptionMonthSubmit,
  submitReportVoc,
  getInfoStepApprove,
  getOptionVocApprove,
  updateApproveStep,
  calculateReportVocAfterUpdateMasterWW,
};
